"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseMessageAttemptEndpointOut = void 0;
class ListResponseMessageAttemptEndpointOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseMessageAttemptEndpointOut.attributeTypeMap;
    }
}
exports.ListResponseMessageAttemptEndpointOut = ListResponseMessageAttemptEndpointOut;
ListResponseMessageAttemptEndpointOut.discriminator = undefined;
ListResponseMessageAttemptEndpointOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<MessageAttemptEndpointOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseMessageAttemptEndpointOut.js.map